import RightComponentsView from './right_components_view';

export default RightComponentsView;
